import { Icon } from 'semantic-ui-react';
import { IPartnerDiscount } from './PartnerDiscountModal';

interface IPartnerDiscountCard {
  partnerDiscount: IPartnerDiscount;
  showAsLocked: boolean;
  onClick: () => void;
}

const PartnerDiscountCard = ({
  partnerDiscount,
  showAsLocked,
  onClick,
}: IPartnerDiscountCard) => {
  const {
    iconComponent,
    discountComponent,
    conditionComponent,
    conditionTextCardOverride,
  } = partnerDiscount;

  return (
    <div className="card" onClick={onClick}>
      <div
        style={{
          fontWeight: 'normal',
          fontSize: '30px',
          position: 'absolute',
          right: '0.4em',
          top: 0,
        }}
      >
        {showAsLocked ? <Icon name="lock" /> : '+'}
      </div>

      <div className="imageContainer">{iconComponent}</div>

      <h5>{discountComponent}</h5>

      <div
        className="separator"
        style={{
          width: '80%',
          margin: '1em auto',
          height: '3px',
          backgroundColor: '#DDD',
        }}
      />

      <p>
        {conditionTextCardOverride
          ? conditionTextCardOverride
          : conditionComponent}
      </p>

      <style jsx>{`
        .card {
          background-color: white;
          margin: 1em;
          padding: 2em 1.5em;
          border-radius: 4px;
          box-shadow: 0 2px 6px 6px rgba(55, 55, 55, 0.2);
          max-width: 510px;
          min-width: 300px;
          flex: 1 1;
          cursor: pointer;
          position: relative;
        }

        .card h5 {
          margin: 0;
        }

        .card p {
          font-style: italic;
          font-weight: 600;
          text-align: center;
        }

        .card .imageContainer {
          height: 70px;
          width: 80%;
          margin: 0 auto 1em auto;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        :global(.card .imageContainer img) {
          height: auto;
          max-height: 100%;
          width: auto;
          max-width: 100%;
        }
      `}</style>
    </div>
  );
};

export default PartnerDiscountCard;
